import { IOpenDrawer } from 'us.collection.partpayments/reducers/AddPartPayment/Interfaces'

export const OpenDrawer: IOpenDrawer = {
    title: "",
    visible: false
}